import { mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import RichText from '../rich-text/RichText';

export const NotFound = styled.div`
  padding: 15px 0;
  max-width: 700px;
  margin: 0 auto;
  text-align: center;

  & > * + * {
    margin-top: 16px;
  }

  & > :first-child {
    margin-top: 0;
  }

  & > :last-child {
    margin-bottom: 16px;
  }
`;

export const FaqRichText = styled(RichText)`
  text-align: left;
  margin-top: 40px;
`;

export const FaqArticleDetails = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 35px;
  margin-top: 25px;

  @media (${mobileXLargeMax}) {
    gap: 15px;
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const FaqArticleDetail = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.textLight};
  gap: 10px;

  svg {
    color: ${({ theme }) => theme.textDark};
  }
`;

export const FaqTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
  margin-top: 30px;
`;

export const FaqTag = styled.div`
  font-size: 14px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.backgroundLighter};
`;

export const BackToTop = styled.div`
  color: ${({ theme }) => theme.primary};
  margin-top: 20px;
  cursor: pointer;
  transition: 300ms all;
  font-size: 14px;
  width: fit-content;
  display: flex;
  align-items: flex-start;
  gap: 7.5px;

  span {
    text-decoration: underline;
  }

  &:hover {
    color: ${(props) => props.theme.backgroundMid};
  }
`;
